















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import shortid from 'shortid';
import { InputVariableViewModel } from '@/features/bots/models/designer';
import { ADD_FLOW_VARIABLE } from '@/store/bot-designer/mutationTypes';
import { required, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

const unique = (value: string, vm: AddNewVariableModal) => {
	return vm.flowVariables.findIndex(v => v.scope === 'flow' && v.name === value) === -1;
};

@Component({
	mixins: [validationMixin],
	validations: {
		newVarName: { required, maxLength: maxLength(50), unique },
	}
})
export default class AddNewVariableModal extends Vue {
	@Getter public flowVariables!: InputVariableViewModel[];
	@Mutation(ADD_FLOW_VARIABLE) public addFlowVariable: (flowVar: InputVariableViewModel) => void;

	public newVarName: string = '';

	public mounted() {
		const inputField = (this.$refs.variableInput as any);
		if (inputField) {
			inputField.focus();
		}
	}

	public save() {
		if (this.$v.$invalid) {
			return;
		}

		const id = shortid.generate();
		const newVar = {
			id: `var-${id}`,
			scope: 'flow',
			key: this.newVarName,
			name: this.newVarName
		};

		this.addFlowVariable(newVar);
		this.$emit('added', newVar);
	}
}
